import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { collection, where, onSnapshot, Unsubscribe, query } from '@firebase/firestore';
import { LoadingService } from 'src/app/loading.service';
import { Author } from './author';
import { Subject } from 'rxjs';
import { AngularFireStorage } from '@angular/fire/compat/storage';

@Injectable({
  providedIn: 'root'
})
export class AuthorsService {

  constructor(public firestore: AngularFirestore, private storage: AngularFireStorage, public loadingService: LoadingService) { this.getAuthors() }
  
  keepFocus = false
  addingNewAuthor = false
  selectedAuthor?: Author
  db = this.firestore.firestore
  authorsListener?: Unsubscribe

  lastAuthorBatch?: Author[] = undefined
  private allAuthors = new Subject<any>();
  public allAuthors$ = this.allAuthors.asObservable();
  // private authorIsBeingEdited = new Subject<any>();
  // public authorIsBeingEdited$ = this.authorIsBeingEdited.asObservable();
  
  addUserCancelled() {
    this.addingNewAuthor = false
    this.keepFocus = false
  }

  async addNewAuthor(author: Author, loadingKey: string, file?: File) {
    const newAuthorDoc = this.db.collection("authors").doc();
    var authorToPost = Object(author)

    delete authorToPost.uid

    if (file != null && file != undefined) {
        const fileExtension = this.returnFileType(file.name)
        const fileName = `${author.firstName}${author.lastName}.${fileExtension}`
        const filePath = `authorPhotos/${fileName}`;
        const ref = this.storage.ref(filePath);
        await ref.put(file);
        authorToPost["picFileName"] = fileName
    }

    newAuthorDoc.set(authorToPost)
    .then(response => {
      this.keepFocus = false
      this.loadingService.removeLoadingKey(loadingKey)
      this.addingNewAuthor = false
      this.selectedAuthor = undefined
      alert("Author added successfully")
    })
    .catch(e => {
      this.loadingService.removeLoadingKey(loadingKey)
      alert(e)
      throw(e)
    });
  }

  async updateAuthor(author: Author, newfile?: File) {
    const loadingKey = author.uid!!
    this.loadingService.addLoadingKey(loadingKey)
    const authorDoc = this.db.collection("authors").doc(author.uid);
    
    var authorToPost = Object(author)
    delete authorToPost.uid

    if (newfile != null && newfile != undefined) {
        const fileExtension = this.returnFileType(newfile.name)
        const authorName = `${author.firstName}${author.lastName}`
        const authorNameEncoded = authorName.replace(/[^a-z0-9]/gi, '_').toLowerCase();
        const fileName = `${authorNameEncoded}.${fileExtension}`
        const filePath = `authorPhotos/${fileName}`;
        const ref = this.storage.ref(filePath);
        await ref.put(newfile);
        authorToPost["picFileName"] = fileName
    }

    authorDoc.update(authorToPost)
    .then(response => {
      this.keepFocus = false
      this.loadingService.removeLoadingKey(loadingKey)
      this.addingNewAuthor = false
      this.selectedAuthor = undefined
      alert("Author Updated successfully")
    })
    .catch(e => {
      this.loadingService.removeLoadingKey(loadingKey)
      alert(e)
      throw(e)
    });
  }

  getAuthors() {
    if (this.authorsListener != null) {
      return
    }

    const q = query(collection(this.db, "authors"));
    this.authorsListener = onSnapshot(q, (querySnapshot) => {
      const snapshotAuthors: Author[] = []
      querySnapshot.forEach((doc) => {
        const data = doc.data()
        const uid = doc.id
        const firstName = data["firstName"]
        const lastName = data["lastName"]
        const picFileName = data["picFileName"]
        const bio = data["bio"]

        const author = { uid, firstName, lastName, bio, picFileName } as Author
        snapshotAuthors.push(author)
      });
      snapshotAuthors.sort((a, b) => a.lastName > b.lastName ? -1 : 1);
      this.allAuthors.next(snapshotAuthors)
      this.lastAuthorBatch = snapshotAuthors
    },
      (error) => {
        alert(error)
        throw(error)
      });;
  }

  async deleteAuthor(author: Author) {
    const loadingKey = author.lastName
    this.loadingService.addLoadingKey(loadingKey)
    const authorDoc = this.db.collection("authors").doc(author.uid);
    
    authorDoc.delete()
    .then(response => {
      this.keepFocus = false
      this.loadingService.removeLoadingKey(loadingKey)
      this.addingNewAuthor = false
      this.selectedAuthor = undefined
      alert("Author Removed successfully")
    })
    .catch(e => {
      this.loadingService.removeLoadingKey(loadingKey)
      alert(e)
      throw(e)
    });
  }

  //FIXME: - fire this
  signout() {
    if (this.authorsListener != null) {
      this.authorsListener()
    }
  }

  returnFileType(fileName: string) {
    return fileName.split('.').pop();
  }
}
